import { combineReducers } from 'redux';
import account from './account';

export default combineReducers({
    account
});